import React, { FunctionComponent, PropsWithChildren } from 'react';

import { useSelector } from 'react-redux';

import { isMessengerIntegration as selectIsMessengerIntegration } from '../../../../../config/selectors';
import { HideParticipantsVideoTumbler, JoinWithCameraOffTumbler, ShowMeTumbler } from '../../tumblers';
import { BandwidthEffective4kCodecTumbler } from '../../tumblers/bandwidth-effective-4k-codec-tumbler';

export type VideoControlsProps = PropsWithChildren<object>;

export const VideoControls: FunctionComponent<VideoControlsProps> = ({ children }) => {
    const isMessengerIntegration = useSelector(selectIsMessengerIntegration);

    return (
        <>
            {children}
            {!isMessengerIntegration && <JoinWithCameraOffTumbler />}
            <ShowMeTumbler />
            <HideParticipantsVideoTumbler />
            <BandwidthEffective4kCodecTumbler />
        </>
    );
};
